import { __assign } from "tslib";
import React from 'react';
import { Grid, CardMedia } from '@material-ui/core';
import { Modal } from '..';
// eslint-disable-next-line no-unused-vars
import { StyledButton } from '../../Button';
export var CancelModal = function (options) {
    var open = options.open, className = options.className, description = options.description, onClickConfirm = options.onClickConfirm, onClickCancel = options.onClickCancel, handleClose = options.handleClose, styles = options.styles, img = options.img, messages = options.messages;
    return (React.createElement(Modal, __assign({}, options, { open: open, handleClose: handleClose, body: React.createElement(Grid, { item: true, className: className + " CancelModal", container: true, direction: 'column', alignItems: 'center' },
            React.createElement(Grid, { item: true },
                React.createElement(CardMedia, { component: 'img', image: img })),
            React.createElement(Grid, { item: true },
                React.createElement(Grid, { container: true, direction: 'column', alignItems: 'center' },
                    React.createElement(Grid, { item: true },
                        React.createElement("h2", null,
                            messages.TITLE,
                            React.createElement("text", { className: 'orangeText' }, "?"))),
                    description && (React.createElement(Grid, { item: true },
                        React.createElement("div", { className: 'description' }, description))))),
            React.createElement(Grid, { item: true },
                React.createElement(Grid, { container: true, direction: 'row', spacing: 6 },
                    React.createElement(Grid, { item: true },
                        React.createElement(StyledButton, { className: 'secondary', onClick: onClickCancel, styles: styles }, messages.CANCEL_BUTTON)),
                    React.createElement(Grid, { item: true },
                        React.createElement(StyledButton, { className: 'default', onClick: onClickConfirm, styles: styles }, messages.CONTINUE_BUTTON))))) })));
};
//# sourceMappingURL=CancelModal.js.map